<template>
  <div class="pr-1 pl-1">
    <div class="no-gutters mt-1 ml-3 mr-3">
      <div class="row pl-2 pb-2 pt-1" v-if="'commands' in this.$route.query && this.campaignType(this.selectedCampaign) === this.CAMPAIGN_TYPE_INPROGRESS">
        <div class="col">
          <b-button class="btn btn-xs" variant="secondary" disabled>All commands..</b-button>
          <b-button class="btn btn-xs ml-1" variant="secondary" v-on:click="sendPing(widget, platformId)">Ping</b-button>
          <b-dropdown size="xs" variant="secondary" split text="Request" class="ml-1 btn-dropdown" v-on:click="requestMessage(widget, platformId, 129)">
            <b-dropdown-item-button v-on:click="requestMessage(widget, platformId, 129)">Platform</b-dropdown-item-button>
            <b-dropdown-item-button v-on:click="requestMessage(widget, platformId, 130)">CTD</b-dropdown-item-button>
            <b-dropdown-item-button v-on:click="requestMessage(widget, platformId, 136)">Camera</b-dropdown-item-button>
            <b-dropdown-item-button v-on:click="requestMessage(widget, platformId, 147)">Fluorometer</b-dropdown-item-button>
            <b-dropdown-item-button v-on:click="requestMessage(widget, platformId, 148)">Optode</b-dropdown-item-button>
            <b-dropdown-item-button disabled>Sonar</b-dropdown-item-button>
            <b-dropdown-item-button disabled>Multibeam</b-dropdown-item-button>
          </b-dropdown>
          <b-dropdown size="xs" variant="secondary" text="Control" class="ml-1">
            <b-dropdown-item-button v-on:click="resetTimer(widget, platformId)">Reset timer</b-dropdown-item-button>
            <b-dropdown-item-button v-on:click="startMission(widget, platformId)">Start mission</b-dropdown-item-button>
            <b-dropdown-item-button v-on:click="enableThruster(widget, platformId)">Enable thrusters</b-dropdown-item-button>
            <b-dropdown-item-button v-on:click="disableThruster(widget, platformId)">Disable thrusters</b-dropdown-item-button>
            <b-dropdown-item-button v-on:click="setIdle(widget, platformId)">Disable all and set idle</b-dropdown-item-button>
          </b-dropdown>
          <b-dropdown size="xs" variant="secondary" text="Positioning" class="ml-1">
            <b-dropdown-item-button v-on:click="widget.$root.$emit('enableUsblPinging', platformId)">Enable pinging</b-dropdown-item-button>
            <b-dropdown-item-button v-on:click="widget.$root.$emit('enableUsblPositioning', platformId)">Enable positioning</b-dropdown-item-button>
            <b-dropdown-item-button v-on:click="widget.$root.$emit('disableUsblPingingAndPositioning', platformId)">Disable ping. / pos.</b-dropdown-item-button>
            <b-dropdown-item-button v-on:click="enableRanging(widget, platformId)">Enable LBL ranging</b-dropdown-item-button>
            <b-dropdown-item-button v-on:click="disableRanging(widget, platformId)">Disable LBL ranging</b-dropdown-item-button>
          </b-dropdown>
          <b-button class="btn btn-xs ml-1" variant="warning" v-on:click="keepPosition(widget, platformId)">Keep position</b-button>
          <b-dropdown size="xs" variant="danger" split text="Abort" class="ml-1 btn-drop" v-on:click="abortAndSurface(widget, platformId)">
            <b-dropdown-item-button variant="warning" v-on:click="abortAndSurface(widget, platformId)">Abort and surface</b-dropdown-item-button>
            <b-dropdown-item-button variant="danger" v-on:click="emergencySurface(widget, platformId)"><strong>Emergency surface</strong></b-dropdown-item-button>
            <b-dropdown-item-button variant="danger" v-on:click="cancelEmergencySurface(widget, platformId)"><strong>Cancel emergency surface</strong></b-dropdown-item-button>
          </b-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="parameter-box">
            <h5 v-b-popover.hover.bottom="{ content: latitude + ', ' + longitude, html: false }">
              {{ position }}
              <b-button v-on:click="copyCoordinates" variant="outline-secondary" class="p-1" size="xs" title="Copy decimal coordinates to clipboard">
                <font-awesome-icon :icon="['fas', 'copy']"></font-awesome-icon>
              </b-button>
            </h5>
            <div class="parameter-name">Current position</div>
          </div>
        </div>
        <div class="col-3">
          <div class="parameter-box">
            <h4 v-if="speed !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 6)" title="Show speed in chart and map">{{ showDigits(roundDigits(speed, 1), 1) }}</a> <small>m/s</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Speed</div>
          </div>
        </div>
        <div class="col-3">
          <div class="parameter-box">
            <h4 v-if="heading !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 3)" title="Show heading in chart and map">{{ roundDigits(heading, 1) }}</a><small>&deg;</small>
              <font-awesome-icon :icon="['fas', 'location-arrow']" size="xs" class="text-info ml-2" :style="{ transform: rotateArrow(heading) }" />
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Heading</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <div class="parameter-box">
            <h4 v-if="depth !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 4)" title="Show depth in chart and map">{{ showDigits(roundDigits(depth, 1), 1) }}</a> <small>m</small>
              <font-awesome-icon v-if="velocity_z < -0.1" size="sm" class="ml-1 align-baseline" :icon="['fas', 'long-arrow-alt-up']" />
              <font-awesome-icon v-if="velocity_z > 0.1" size="sm" class="ml-1 align-baseline" :icon="['fas', 'long-arrow-alt-down']" />
              <span v-if="Math.abs(velocity_z) > 0.1" class="text-muted align-middle velocity-z">
                <a href="#" class="parameter-link" @click="selectParameter(1, 7)" title="Show velocity z in chart and map">{{ roundDigits(Math.abs(velocity_z), 1) }}</a> <small>m/s</small>
              </span>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">
              Depth <font-awesome-icon :icon="['fas', 'circle']" size="xs" class="text-primary align-baseline" />
            </div>
          </div>
        </div>
        <div class="col-2 align-self-end">
          <sparkline :width="80" :height="35" :indicatorStyles="spStyles" :refLineType="false" class="mb-1">
            <!-- TODO: Change tooltip values -->
            <sparklineLine :data="spDepthData" :limit="spDepthData.length" :styles="spLineStylesDepth" :refLineStyles="{}" :max="spMinWaterDepth" :min="spMaxWaterDepth" />
            <sparklineLine :data="spAltitudeData" :limit="spAltitudeData.length" :styles="spLineStylesAltitude" :refLineStyles="{}" :max="spMinWaterDepth" :min="spMaxWaterDepth" />
          </sparkline>
        </div>
        <div class="col-3">
          <div class="parameter-box">
            <h4 v-if="altitude !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 5)" title="Show altitude in chart and map"><span :class="altitude_class">{{ showDigits(roundDigits(altitude, 1), 1) }}</span></a> <small>m</small>
              <small><span class="text-muted ml-1" style="font-size: 11px">({{ dvl_data_age }} s ago)</span></small>
              <!-- TODO: computed property with customized minimum altitude -->
              <!-- <font-awesome-icon class="text-warning ml-2 align-baseline" size="xs" v-if="altitude < 0.8" :icon="['fas', 'exclamation-triangle']" />-->
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">
              Altitude <font-awesome-icon :icon="['fas', 'circle']" size="xs" class="text-danger align-baseline" />
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="parameter-box">
            <h4 v-if="pitch !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 10)" title="Show pitch in chart and map">{{ showDigits(pitch, 1) }}</a><small>&deg;</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Pitch</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="parameter-box">
            <h4 :class="captain_state_class">{{ captain_state }}</h4>
            <div class="parameter-name">Captain state</div>
          </div>
        </div>
        <div class="col-3">
          <div class="parameter-box">
            <h4 v-if="step !== null && total_steps !== null">
              <a href="#" class="parameter-link" @click="selectParameter(4, 2)" title="Show current step in chart and map">{{ step }}</a> /
              <a href="#" class="parameter-link" @click="selectParameter(4, 3)" title="Show total steps in chart and map">{{ total_steps }}</a>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Current step</div>
          </div>
        </div>
        <div class="col-3">
          <div class="parameter-box">
            <h4 v-if="battery !== null">
              <a href="#" class="parameter-link" @click="selectParameter(3, 9)" title="Show battery in chart and map">{{ battery }}</a><small>%</small>
              <font-awesome-icon class="text-success ml-1 align-baseline" rotation="270" size="xs" v-if="battery > 75" :icon="['fas', 'battery-full']" />
              <font-awesome-icon class="text-success ml-1 align-baseline" rotation="270" size="xs" v-else-if="battery > 50 && battery <= 75" :icon="['fas', 'battery-three-quarters']" />
              <font-awesome-icon class="text-warning ml-1 align-baseline" rotation="270" size="xs" v-else-if="battery > 25 && battery <= 50" :icon="['fas', 'battery-half']" />
              <font-awesome-icon class="text-warning ml-1 align-baseline" rotation="270" size="xs" v-else-if="battery > 10 && battery <= 25" :icon="['fas', 'battery-quarter']" />
              <font-awesome-icon class="text-danger ml-1 align-baseline" rotation="270" size="xs" v-else-if="battery < 10" :icon="['fas', 'battery-empty']" />
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Battery charge</div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-3 d-none d-sm-block">
          <span class="ml-2 dashboard-group-header">Positioning:</span>
        </div>
        <div class="col-9 d-none d-sm-block">
          <hr class="mr-2 dashboard-group-header-hr">
        </div>
        <div class="col-6 d-block d-sm-none">
          <span class="ml-2 dashboard-group-header">Positioning:</span>
        </div>
        <div class="col-6 d-block d-sm-none">
          <hr class="mr-2 dashboard-group-header-hr">
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <div class="parameter-box">
            <h4 ref="usbl_long_lastupdate" :class="getPositioningClass(usbl_long_lastupdate)">n/a</h4>
            <div class="parameter-name">Last USBL fix</div>
          </div>
        </div>
        <div class="col-3">
          <div class="parameter-box">
            <h4 ref="usbl_angles_lastupdate" :class="getPositioningClass(usbl_angles_lastupdate)">n/a</h4>
            <div class="parameter-name">Last USBL angles</div>
          </div>
        </div>
        <div class="col-3">
          <div class="parameter-box">
            <h4 ref="lbl_lastupdate" :class="getPositioningClass(lbl_lastupdate)">n/a</h4>
            <div class="parameter-name">Last LBL fix</div>
          </div>
        </div>
        <div class="col-3">
          <div class="parameter-box">
            <h4 ref="iridium_lastupdate" :class="getPositioningClass(iridium_lastupdate)">n/a</h4>
            <div class="parameter-name">Last Iridium fix</div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-gutters mb-3 ml-4 mr-4">
      <div class="row">
        <div class="col">
          <hr class="p-0 mb-2">
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <div class="state-box" :class="getTimerStyle(global_timer)">
            Global timer ({{ global_timer }} secs)
          </div>
        </div>
        <div class="col-4">
          <div class="state-box" :class="getKeepAliveStyle(keep_alive)">
            Network <span v-if="keep_alive">available</span><span v-else>not available</span>
          </div>
        </div>
        <div class="col-4">
          <div class="state-box" :class="getThrusterStyle(thrusters_enabled)">
            Thrusters <span v-if="thrusters_enabled">enabled</span><span v-else>disabled</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
            <hr class="p-0 mt-2 mb-2">
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <div class="state-box" :class="getStateStyle(low_battery, false)">
            Low battery
          </div>
        </div>
        <div class="col-4">
          <div class="state-box" :class="getStateStyle(no_altitude)">
            Altitude error
          </div>
        </div>
        <div class="col-4">
          <div class="state-box" :class="getStateStyle(emergency_surface)">
            Emergency surface
          </div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-4">
          <div class="state-box" :class="getStateStyle(high_temperature)">
            High temperature
          </div>
        </div>
        <div class="col-4">
          <div class="state-box" :class="getStateStyle(navigation_error)">
            Navigation error
          </div>
        </div>
        <div class="col-4">
          <div class="state-box" :class="getStateStyle(abort_and_surface)">
            Abort and surface
          </div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-4">
          <div class="state-box" :class="getStateStyle(water_detected)">
            Water inside
          </div>
        </div>
        <div class="col-4">
          <div class="state-box" :class="getStateStyle(battery_error)">
            Battery error
          </div>
        </div>
        <div class="col-4">
          <div class="state-box" :class="getStateStyle(abort_mission)">
            Abort mission
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import Helpers from '@/mixins/helpers'
import BelugaMessageFactory from '@/mixins/beluga_messagefactory'
import Sparkline from 'vue-sparklines'
import moment from 'moment'

const SEC_MS = 1000

const CAMPAIGN_TYPE_INPROGRESS = 1
const UPDATE_DEPTH_ALTITUDE_INTERVAL_MS = 2000
const UPDATE_KEEPALIVE_INTERVAL_MS = 1000
const UPDATE_INTERVALS_MS = 1000
const GLOBAL_TIMER_MIN_SEC = 300
const KEEPALIVE_MIN_MS = 2000

const TIMEOUT_USBL_WARNING = 60
const TIMEOUT_USBL_DANGER = 300

export default {
  name: 'AuvDashboardWidget',
  mixins: [
    Helpers,
    BelugaMessageFactory
  ],
  components: {
    Sparkline
  },
  data: function () {
    return {
      widget: this,
      CAMPAIGN_TYPE_INPROGRESS: CAMPAIGN_TYPE_INPROGRESS,
      spStyles: {},
      spDepthData: (() => {
        return []
      })(),
      spLineStylesDepth: {
        stroke: '#007bff'
      },
      spAltitudeData: (() => {
        return []
      })(),
      spLineStylesAltitude: {
        stroke: '#dc3545'
      },
      spMinWaterDepth: 0,
      spMaxWaterDepth: 0,
      spDepthDataSize: 30,
      keepAlive: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      setInterval(this.updateDepthAltitudeLines, UPDATE_DEPTH_ALTITUDE_INTERVAL_MS)
      setInterval(this.checkKeepAlive, UPDATE_KEEPALIVE_INTERVAL_MS)
      // Initialize last change timestamp
      this.updateLastUpdates()
      // Start last change timestamp updater
      this.updateTask = setInterval(this.updateLastUpdates, UPDATE_INTERVALS_MS)
    })
  },
  beforeDestroy: function () {
    // Remove background job again
    clearInterval(this.updateTask)
  },
  props: ['platformId'],
  methods: {
    ...mapMutations(['select_parameter']),
    getAge: function (timestamp, skip) {
      if (timestamp > 0) {
        return moment.unix(timestamp).fromNow(skip)
      } else {
        return 'never'
      }
    },
    selectParameter: function (entityId, parameterId) {
      this.select_parameter([this.platformId, entityId, parameterId])
    },
    updateLastUpdates: function () {
      const usblTs = this.usbl_long_lastupdate
      if (usblTs > 0) {
        this.$refs.usbl_long_lastupdate.innerText = this.getAge(usblTs, false)
      }
      const lblTs = this.lbl_lastupdate
      if (lblTs > 0) {
        this.$refs.lbl_lastupdate.innerText = this.getAge(lblTs, false)
      }
    },
    copyCoordinates: function () {
      this.$copyText(this.latitude + ', ' + this.longitude).then(function (e) {
        // No user response intended
      }, function (e) {
        alert('auv dashboard widget: Error while trying to copy coordinates')
      })
    },
    checkKeepAlive: function () {
      if (this.platformId in this.platforms) {
        if ((Date.now() - this.platforms[this.platformId].keep_alive) < KEEPALIVE_MIN_MS) {
          this.keepAlive = true
          return
        }
      }
      this.keepAlive = false
    },
    updateDepthAltitudeLines: function () {
      if (this.depth != null) {
        if (this.spDepthData.length > this.spDepthDataSize) {
          this.spDepthData.shift()
        }
        this.spDepthData.push(-this.depth)
      }
      if (this.altitude != null) {
        if (this.spAltitudeData.length > this.spDepthDataSize) {
          this.spAltitudeData.shift()
        }
        this.spAltitudeData.push(-(this.depth + this.altitude))
      }
      this.spMinWaterDepth = Math.min.apply(Math, this.spDepthData) + 5
      this.spMaxWaterDepth = Math.min.apply(Math, this.spAltitudeData)
    },
    getKeepAliveStyle: function (state) {
      if (state) {
        return 'state-ok'
      } else {
        return 'state-warning'
      }
    },
    getStateStyle: function (state, danger = true) {
      if (state) {
        if (danger) {
          return 'state-danger'
        }
        return 'state-warning'
      } else {
        return 'state-ok'
      }
    },
    getThrusterStyle: function (state) {
      if (state === true) {
        return 'state-ok'
      } else {
        return 'state-warning'
      }
    },
    getTimerStyle: function (timer) {
      if (timer === 0) {
        return 'state-danger'
      } else if (timer <= GLOBAL_TIMER_MIN_SEC) {
        return 'state-warning'
      } else {
        return 'state-ok'
      }
    },
    getPositioningClass: function (lastupdate) {
      if (lastupdate > 0) {
        const diff = (Date.now() / SEC_MS) - lastupdate
        if (diff > TIMEOUT_USBL_DANGER) {
          return 'text-danger'
        } else if (diff >= TIMEOUT_USBL_WARNING) {
          return 'text-warning'
        }
        return ''
      }
      return 'text-muted'
    },
    rotateArrow: function (heading) {
      return 'rotate(' + Number(Number(heading) - 45) + 'deg)'
    }
  },
  computed: {
    ...mapState(['platforms', 'selectedCampaign']),
    ...mapGetters(['lastUpdate', 'currentUpdate', 'campaignType', 'parameter']),
    position () {
      const position = this.getCoordinatesNautical(this.roundDigits(this.latitude, 5),
        this.roundDigits(this.longitude, 5))
      return position.lat + ' ' + position.lng
    },
    latitude () {
      const update = this.currentUpdate(this.platformId, 1, 1)
      return (update.length !== 0) ? update[1] : 0
    },
    longitude () {
      const update = this.currentUpdate(this.platformId, 1, 2)
      return (update.length !== 0) ? update[1] : 0
    },
    heading () {
      const update = this.currentUpdate(this.platformId, 1, 3)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    depth () {
      const update = this.currentUpdate(this.platformId, 1, 4)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    altitude () {
      const update = this.currentUpdate(this.platformId, 1, 5)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    dvl_data_age () {
      const update = this.currentUpdate(this.platformId, 5, 1)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    altitude_class () {
      const update = this.currentUpdate(this.platformId, 1, 5)
      if (update.length !== 0) {
        if (String(update[1]) === 'True') {
          return 'text-danger'
        } else if (String(update[1]) !== 'False' && Number(update[1]) < 0.8) { // FIXME: Magic number
          return 'text-warning'
        }
      }
      return ''
    },
    speed () {
      const update = this.currentUpdate(this.platformId, 1, 6)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    velocity_z () {
      const update = this.currentUpdate(this.platformId, 1, 7)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    battery () {
      const update = this.currentUpdate(this.platformId, 3, 9)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    pitch () {
      const update = this.currentUpdate(this.platformId, 1, 10)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    step () {
      const update = this.currentUpdate(this.platformId, 4, 2)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    total_steps () {
      const update = this.currentUpdate(this.platformId, 4, 3)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    captain_state () {
      const update = this.currentUpdate(this.platformId, 4, 6)
      if (update.length !== 0) {
        switch (Number(update[1])) {
          case 0:
            return 'Idle'
          case 1:
            return 'Goto'
          case 2:
            return 'Mission'
          case 3:
            return 'Keep position'
          case 4:
            return 'Safety keep'
          case 5:
            return 'Ext. mission'
          case 6:
            return 'Section'
          default:
        }
      }
      return '-'
    },
    captain_state_class () {
      const update = this.currentUpdate(this.platformId, 4, 6)
      if (update.length !== 0) {
        switch (Number(update[1])) {
          case 0:
            return 'text-muted'
          case 1:
          case 2:
          case 5:
            return 'text-info'
          case 3:
          case 4:
          case 6:
            return 'text-warning'
          default:
        }
      }
      return 'text-danger'
    },
    thrusters_enabled () {
      const update = this.currentUpdate(this.platformId, 2, 6)
      if (update.length !== 0) {
        if (Number(update[1]) === 1) {
          return true
        }
      }
      return false
    },
    emergency_surface () {
      const update = this.currentUpdate(this.platformId, 2, 1)
      return (update.length !== 0) ? update[1] : false
    },
    high_temperature () {
      const update = this.currentUpdate(this.platformId, 2, 2)
      return (update.length !== 0) ? update[1] : false
    },
    water_detected () {
      const update = this.currentUpdate(this.platformId, 2, 3)
      return (update.length !== 0) ? update[1] : false
    },
    abort_and_surface () {
      const update = this.currentUpdate(this.platformId, 2, 4)
      return (update.length !== 0) ? update[1] : false
    },
    navigation_error () {
      const update = this.currentUpdate(this.platformId, 1, 18)
      return (update.length !== 0) ? update[1] : false
    },
    low_battery () {
      const update = this.currentUpdate(this.platformId, 3, 2)
      return (update.length !== 0) ? update[1] : false
    },
    battery_error () {
      const update = this.currentUpdate(this.platformId, 3, 3)
      return (update.length !== 0) ? update[1] : false
    },
    abort_mission () {
      const update = this.currentUpdate(this.platformId, 4, 1)
      return (update.length !== 0) ? update[1] : false
    },
    no_altitude () {
      const update = this.currentUpdate(this.platformId, 5, 2)
      return (update.length !== 0) ? update[1] : false
    },
    global_timer () {
      const update = this.currentUpdate(this.platformId, 2, 5)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    keep_alive () {
      return this.keepAlive
    },
    usbl_long_lastupdate () {
      const parameter = this.parameter(this.platformId, 13, 3)
      if (typeof parameter !== 'undefined' && parameter.current.length !== 0) {
        return Number(parameter.current[0] / 1000)
      }
      return 0
    },
    usbl_angles_lastupdate () {
      const parameter = this.parameter(this.platformId, 16, 3)
      if (typeof parameter !== 'undefined' && parameter.current.length !== 0) {
        return Number(parameter.current[0] / 1000)
      }
      return 0
    },
    lbl_lastupdate () {
      const parameter = this.parameter(this.platformId, 14, 3)
      if (typeof parameter !== 'undefined' && parameter.current.length !== 0) {
        return Number(parameter.current[0] / 1000)
      }
      return 0
    },
    iridium_lastupdate () {
      const parameter = this.parameter(this.platformId, 17, 3)
      if (typeof parameter !== 'undefined' && parameter.current.length !== 0) {
        return Number(parameter.current[0] / 1000)
      }
      return 0
    }
  }
}
</script>

<style lang="scss" scoped>

  .btn-drop .btn {
    font-size: 40px;
    font-weight: bold;
  }
  .parameter-box {
    padding: 10px 0 0 10px;
  }
  .parameter-box h4 {
    margin-bottom: 2px;
  }
  .parameter-box h5 {
    margin-bottom: 2px;
  }
  .parameter-name {
    font-size: 11px;
    color: #6c757d;
  }
  .parameter-link {
    color: #212529;
    text-decoration: none;
  }
  .state-box {
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    vertical-align: bottom;
    border-radius: 2px;
    padding: 5px 2px 5px 2px;
  }
  .state-muted {
    background-color: rgba(0,0,0,.05);
    color: #6c757d;
  }
  .state-ok {
    background-color: #82E0AA;
    color: #186A3B;
  }
  .state-danger {
    background-color: #F1948A;
    color: #78281F;
  }
  .state-warning {
    background-color: #ffc107;
    color: #755905;
  }
  .no-gutters {
    margin-right: 10px;
    margin-left: 10px;
    .col, [class*="col-"] {
      padding-right: 2px;
      padding-left: 2px;
    }
  }
  .velocity-z {
    font-size: 15px;
  }
  .dashboard-group-header {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.25);
    font-weight: bold;
  }
  .dashboard-group-header-hr {
    margin-block-end: 0;
  }

</style>
